var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12416_144341)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12416_144341",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H18V18H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12416_144341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7285 3.4823L4.77713 1.31618C4.07281 1.05984 3.29403 1.42299 3.03769 2.1273L1.71678 5.75643C1.31725 6.85412 1.43835 8.07387 2.04591 9.07155L3.34494 11.2047C3.78513 11.9276 4.66756 12.2487 5.46938 11.9779L7.83566 11.1789C8.94238 10.8051 9.81919 9.94855 10.2187 8.8509L11.5396 5.22177C11.796 4.51746 11.4328 3.73865 10.7285 3.4823Z",
    stroke: "#1A1D1F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5867 8.35148C4.86467 8.08867 4.25983 7.69151 3.83904 7.24426C3.60258 8.2362 4.14114 9.26957 5.12254 9.62679C6.10395 9.98398 7.18073 9.53854 7.63723 8.6267C7.02739 8.69882 6.30876 8.61429 5.5867 8.35148Z",
    stroke: "#1A1D1F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.50998 5.91602C5.4311 5.60073 5.17895 5.31411 4.81451 5.18148C4.45007 5.04883 4.0727 5.1063 3.80957 5.29714",
    stroke: "#1A1D1F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91086 7.1543C8.83198 6.83898 8.57982 6.55239 8.21539 6.41977C7.85095 6.28711 7.47357 6.34458 7.21045 6.53539",
    stroke: "#1A1D1F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 11.5L7.78115 13.5433C8.18068 14.6409 9.05749 15.4975 10.1642 15.8712L12.5305 16.6703C13.3323 16.9411 14.2147 16.6199 14.6549 15.8971L15.954 13.7639C16.5615 12.7663 16.6826 11.5465 16.2831 10.4488L14.9622 6.81966C14.7059 6.11535 13.9271 5.75219 13.2227 6.00853L11 7",
    stroke: "#1A1D1F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5677 13.468C13.2897 13.2052 14.0083 13.1206 14.6182 13.1928C14.1617 12.2809 13.0849 11.8355 12.1035 12.1927C11.1221 12.5499 10.5835 13.5833 10.82 14.5752C11.2408 14.1279 11.8456 13.7308 12.5677 13.468Z",
    stroke: "#1A1D1F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.07617 11.6289C9.37983 11.7448 9.75917 11.7021 10.0766 11.4793C10.394 11.2565 10.563 10.9142 10.5572 10.5892",
    stroke: "#1A1D1F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0606 9.81463C13.9025 10.0986 13.5845 10.3098 13.1981 10.3431C12.8117 10.3765 12.4622 10.2229 12.2578 9.97019",
    stroke: "#1A1D1F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12416_144341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenreIcon);
export default __webpack_public_path__ + "static/media/Genre_Icon.72e876e642cc420b0b66a36eca5d8e98.svg";
export { ForwardRef as ReactComponent };